import { useCallback } from "react";

export default function useSmoothScroll() {
  const scrollToElement = useCallback((targetElementId, duration = 600, offset = 0, containerId = null) => {
    const targetElement = document.getElementById(targetElementId);
    
    if (!targetElement) {
      console.warn(`Element with ID "${targetElementId}" not found`);
      return;
    }

    const container = containerId ? document.getElementById(containerId) : null;
    
    if (containerId && !container) {
      console.warn(`Container with ID "${containerId}" not found`);
      return;
    }

    const isWindowScroll = !container;
    const getScrollTop = () => isWindowScroll ? window.scrollY : container.scrollTop;
    const getBoundingRect = () => {
      if (isWindowScroll) {
        return targetElement.getBoundingClientRect().top + window.scrollY;
      } else {
        const containerRect = container.getBoundingClientRect();
        const targetRect = targetElement.getBoundingClientRect();
        return targetRect.top - containerRect.top + container.scrollTop;
      }
    };

    const targetY = getBoundingRect() - offset;
    const startY = getScrollTop();
    const distance = targetY - startY;
    const startTime = performance.now();

    function smoothScroll(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const ease = 1 - Math.pow(1 - progress, 3);
      const scrollPosition = startY + distance * ease;

      if (isWindowScroll) {
        window.scrollTo(0, scrollPosition);
      } else {
        container.scrollTo(0, scrollPosition);
      }

      if (progress < 1) {
        requestAnimationFrame(smoothScroll);
      }
    }

    requestAnimationFrame(smoothScroll);
  }, []);

  return scrollToElement;
}